import * as types from './mutation_types';

export default {
  [types.CITY_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.CITY_RESET](state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      items: [],
      item: null,
    });
  },

  [types.CITY_SET_LOADING](state, loading) {
    Object.assign(state, { isLoading: loading });
  },

  [types.CITY_SET_ITEMS](state, items) {
    Object.assign(state, { items: items });
  },

  [types.CITY_SET_ITEM](state, item) {
    Object.assign(state, { item: item });
  },
};
